<template>
  <div>
    <PageList></PageList>
  </div>
</template>

<script>
  import PageList from './page/index.vue';
  export default {
    name: 'assetsRentalList',
    components: { PageList },
  };
</script>

<style></style>
